<template>
  <div @click="openWin" class="symptom_select_input">
    <div class="text" v-if="value.length">
      <span
        class="symptom_name"
        v-for="item in value"
        :key="'dsId_' + item.dsId"
      >
        <symptomChanges :symptomInfo="item">
          {{ item.dsName }}
        </symptomChanges>
      </span>
    </div>
    <div v-else class="text placeholder">
      {{ placeholder }}
    </div>

    <Modal
      class="condition symptom_select_input"
      fullscreen
      v-model="showWin"
      title="病历症状录入"
      footer-hide
    >
      <template slot="header">
        <div class="ivu-modal-header-inner">病历症状录入</div>
        <div class="pathent-info">
          <i class="iconfont icon-ren"></i>
          <uArchives :info="info">
            <span class="pathent-info-name">{{ info.patientName }}</span>
          </uArchives>
          <span class="pathent-info-sex">
            <Icon v-if="info.sex == '男'" type="md-male" />
            <Icon v-else type="md-female" />
            {{ info.sex }}
          </span>
          <span class="pathent-info-age">{{ info.patientAge }}岁</span>
          <span class="pathent-info-cellphoneNo">{{
            common.phone(info.cellphoneNo)
          }}</span>
          <uArchives :info="info"></uArchives>
        </div>
        <div class="btn_group">
          <Button @click="close">退出</Button>
          <Button type="primary" @click="send">{{
            filterDtId ? "保存" : "确认选择"
          }}</Button>
        </div>
      </template>
      <symptom-select
        sort
        :filterDtId="filterDtId"
        :quote="quote"
        ref="symptomSelect"
        :sexAndAge="sexAndAge"
        v-model="selectList"
        @clickItem="clickItem2"
        @clickMenu="clickMenu"
      />
      <div class="s_s_i_list">
        <div class="s_s_i_list_body">
          <div class="right">
            <template v-if="!showMore">
              <div class="s_body">
                <div class="hlwyy" v-if="info.isInternetHospital">
                  <div class="hlwyy-title">互联网线上问诊信息</div>
                  <div class="hlwyy-info">
                    <div>
                      <span class="label">病情描述</span>
                      <strong>（若有症状描述需录入对应症状）</strong>
                    </div>
                    <div>
                      {{ internetAppletVisitDetail.diseaseDescription }}
                    </div>
                    <div>
                      <span class="label">病历图片</span>
                    </div>
                    <div class="pic" ref="images">
                      <div
                        class="img-box"
                        v-for="(
                          item, index
                        ) in internetAppletVisitDetail.medicalNoteImages"
                        :key="index"
                      >
                        <img @click="clickPic" :src="item" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fjcsb has-select-box">
                  <div class="title">已选症状</div>
                  <div v-if="!filterDtId" class="title_right">
                    <Button
                      @click="showLastSymoptom = !showLastSymoptom"
                      size="small"
                      >上次症状</Button
                    >
                    <Button @click="clear" size="small">清空症状</Button>
                  </div>
                </div>
                <span v-for="item in selectList" :key="item.dsId">
                  <symptomDropdown
                    :symptomInfo="item"
                    @clickMenu="clickMenu"
                    parentClass=".right .s_body"
                  >
                    <span
                      class="symptom_name"
                      :class="{ isError: item.active }"
                      @click="onClick(item)"
                    >
                      {{ item.dsName }}
                    </span>
                  </symptomDropdown>
                </span>
              </div>
            </template>
            <last-symptom
              v-if="!filterDtId"
              v-model="showLastSymoptom"
              :patientCode="info.patientCode"
              @selectAll="selectAll"
              @removeSymptom="removeSymptom"
              @jump="jump"
              @clickItem="clickItem"
              @clickMenu="clickMenu"
            />
          </div>
        </div>
      </div>
      <Spin class="u_spin" v-if="indexSpin.show" fix>
        <Icon type="ios-loading" size="30" class="demo-spin-icon-load"></Icon>
        <div>{{ indexSpin.text || "加载中..." }}</div>
      </Spin>
    </Modal>

    <Modal
      v-model="modal1"
      title="提示"
      footer-hide
      class-name="symptom-omission-selection"
    >
      <div class="title">漏选症状?</div>
      <div class="content">
        检测到该患者近期就诊存在
        <span class="t_read">{{ symptomNames }}</span>
        的症状，本次就诊可能漏选，请与患者确认是否仍存在以上症状，是否需要补选?
      </div>
      <div class="footer">
        <Button @click="addSymptom">补选</Button>
        <Button type="primary" @click="modal1 = false">不补选</Button>
      </div>
    </Modal>

    <causeSelection
      v-if="selectEtiology"
      v-model="in_etiologyList"
      ref="etiologySelect"
      :info="info"
      :etiologyIds="etiologyIds"
      :selectList="selectList"
      :isFirstEtiology="isFirstEtiology"
      @change="etiologySelectChange"
    />
    <!-- @submit="send" -->
  </div>
</template>

<script>
import viewer from "viewerjs";
import request from "@/utils/request";
import symptomSelect from "./symptomSelect.vue";
import { mapGetters } from "vuex";
import LastSymptom from "./lastSymptom.vue";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: "",
    },
    filterDtId: {
      //过滤的dtId
      type: String,
      default: "",
    },
    etiologyIdObj: {
      type: Object,
      default: () => {},
    },
    etiologyList: {
      type: Array,
      default: () => [],
    },
    isFirstEtiology: {
      type: Boolean,
      default: false,
    },
  },
  components: { symptomSelect, LastSymptom },
  computed: {
    ...mapGetters([
      "selectEtiology",
      "indexSpin",
      "diagnosticList",
      "diagnosticList2",
      "contradictDiagnosticList", //症状互斥列表
      "userInfo",
      "userSystemConfig",
      "patientCausePool",
    ]),
    causePool() {
      return (
        this.patientCausePool[this.info.registerCode] || null // { body: {}, part: {}, symptomId:"" }
      );
    },
    // 主症状ID
    mainSymptomId() {
      return this.causePool?.symptomId;
    },
    // 是否除上次就诊外的新症状
    isNewSymptom() {
      return this.etiologyIds[this.activeSymptom.value] ? false : true;
    },
    hasOption() {
      return this.selectList.filter((i) => i.etiologyList.length);
    },
    selected() {
      return this.hasOption.filter((j) =>
        j.etiologyList.some((i) => i.children.length)
      );
    },
    notSelected() {
      return this.selectList.filter(
        (i) => !i.isNormal && !i.etiologyList.length
      );
    },
  },
  watch: {
    info(newValue, oldValue) {
      this.again = false; //再次提交
      this.init();
    },
    value() {
      this.init();
    },
    showWin(value) {
      setTimeout(() => {
        this.focus();
      }, 1000);
    },
    etiologyList() {
      this.in_etiologyList = this.etiologyList;
    },
  },
  data() {
    return {
      oldDsIds: [], //修改前的症状ID
      in_etiologyList: [],
      internetAppletVisitDetail: {},
      etiologyIds: {},
      tabsValue: "1",
      showMore: false,
      activeSymptom: {},
      activeSymptom2: {},
      modal1: false,
      symptomNames: "",
      symptomList: [],
      again: false, //再次提交
      isJudgingSymptoms: false, //是否检测怀孕
      showLastSymoptom: false,
      showWin: false,
      selectList: [],
      quote: {
        ids: [],
        type: false,
      },
      sexAndAge: {
        sex: "",
        age: "",
      },
      isRemove: false,
    };
  },
  methods: {
    clickPic() {
      if (this.picView) this.picView.destroy();
      this.picView = new viewer(this.$refs["images"]);
    },
    setDiagnosticListEtiologyList() {
      this.diagnosticList2.forEach((i) => {
        i.etiologyList = [];
        i.symptomChanges = "";
        this.selectList.forEach((j) => {
          if (i.dsId == j.dsId && j.etiologyList) {
            i.etiologyList = j.etiologyList;
            i.symptomChanges = j.symptomChanges;
          }
        });

        let list = this.etiologyIds[i.dsId];
        let list2 = i.etiologyList;
        if (list) {
          if (list2.length) {
            this.addBottomReason(list2, list);
          } else {
            list2.push(...list);
          }
        }
      });
    },

    // 将list2里bottomReason字段里不包含list1的内容加进list1里
    addBottomReason(list1, list2) {
      list2.forEach((i) => {
        list1.forEach((j) => {
          if (i.etiologyId == j.etiologyId) {
            i.bottomReason.forEach((k) => {
              if (!j.bottomReason.includes(k)) {
                j.bottomReason.push(k);
              }
            });
          }
        });
      });
    },

    formatData(obj) {
      let list = [];
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const arr = obj[key];
          arr.forEach((i) => {
            if (!list.find((j) => j.etiologyId == i.etiologyId)) {
              if (this.etiologyIds[i.etiologyId]) {
                i.children = this.etiologyIds[i.etiologyId].children;
                i.value = true;
              } else {
                i.children = [];
                i.value = false;
              }
              list.push(i);
            }
          });
        }
      }
      return list;
    },
    addSymptom() {
      this.drzz(this.symptomList);
      this.modal1 = false;
    },
    focus() {
      if (this.showWin && this.$refs.symptomSelect) {
        this.$refs.symptomSelect.focus();
      }
    },

    onClick(item) {
      this.clickMenu(item, 4);
    },

    clickMenu(item, value) {
      switch (value) {
        case 3: //添加症状
          this.activeSymptom = item;
          this.activeSymptom2 = this.common.clone(item);
          this.addCausePool();
          break;
        case 4: //删除症状
          item.Other = false;
          item.isCause = false;
          this.$refs.symptomSelect.clickSymptoms();
          this.removeSymptomCause(item);
          break;
      }
    },

    // 删除首页选中病因的症状
    removeSymptomCause(item) {
      if (!this.causePool) return; //如果没有池数据，则不执行
      let fItem = this.selectList.find((i) => i.isNormal);
      if (fItem) {
        let r = this.common.getCausePoolData(this.selectList);
        // 如果是要删除的是主症状 则将池里症状ID更新为下一个需要选择病因的症状ID
        let symptomId = this.causePool.symptomId;
        if (item.value == this.causePool.symptomId) {
          symptomId = item.value;
        }
        let obj = {};
        obj[this.info.registerCode] = {
          body: this.causePool.body, //全身数据不修改
          part: r.part, //部位数据更改为最新的
          symptomId,
        };
        this.$store.commit("patientCausePoolAdd", obj);
      } else {
        // 如果没有需要选择病因的症状，则清空病因池
        this.$store.commit("patientCausePoolRemove", this.info.registerCode);
      }
    },

    clickItem2(item) {
      if (!this.userSystemConfig.mustSelectEtiology && this.isFirstEtiology) {
        this.$refs.etiologySelect.open();
      }
      if (this.userSystemConfig.mustSelectEtiology && item.Other) {
        this.activeSymptom = item;
        this.activeSymptom2 = this.common.clone(item);
        this.addCausePool();
      }
    },

    // 将复诊症状的病因池更新到全局
    addCausePool(isClear) {
      setTimeout(() => {
        if (!this.mainSymptomId && !this.isNewSymptom) {
          this.updataCausePool(true);
          this.$refs.etiologySelect.init();
        }
      }, 200);
    },

    etiologySelectChange(list) {
      this.$emit("etiologyListChange", list);
    },

    clickItem(obj) {
      this.$refs.symptomSelect.clickItem(obj.id, obj.type);
    },
    delSymptom(item) {
      item.Other = false;
      this.$refs.symptomSelect.clickSymptoms();
    },
    jump(res) {
      this.$refs.symptomSelect.jump(res.id, res.type);
    },
    removeSymptom(ids) {
      this.quote = {
        ids: [],
        type: false,
      };
      this.$refs.symptomSelect.removeSymptom(ids);
      setTimeout(() => {
        this.updataCausePool(false);
      }, 100);
    },
    selectAll(ids) {
      this.quote = {
        ids: ids,
        type: false,
      };
      setTimeout(() => {
        this.updataCausePool(true);
      }, 100);
    },
    updataCausePool(isAdd) {
      // 如果有值则不更新
      if (isAdd && this.mainSymptomId) return;
      let item = this.selectList.find((i) => !i.isNormal);
      this.setIsCause();

      if (!item) {
        if (!isAdd) {
          this.$store.commit("patientCausePoolRemove", this.info.registerCode);
        }
        return; // 如果没有非正常症状则不更新
      }

      let r = this.common.getCausePoolData(this.selectList);
      let obj = {};
      obj[this.info.registerCode] = {
        ...r,
        symptomId: "", //item.value,
      };
      this.$store.commit("patientCausePoolAdd", obj);
    },
    getInternetAppletVisitDetailByAppointNo() {
      return new Promise((resolve, reject) => {
        request
          .post("/zhbusiness/getInternetAppletVisitDetailByAppointNo", {
            appointNo: this.info.appointNo,
          })
          .then((res) => {
            // 测试
            // res.result.doctorReceptionStatus = 0;
            resolve(res.result);
          })
          .catch(reject);
      });
    },
    async openWin() {
      this.oldDsIds = this.value.map((i) => i.dsId);
      if (this.info.isInternetHospital) {
        this.internetAppletVisitDetail =
          await this.getInternetAppletVisitDetailByAppointNo();
        if (!this.internetAppletVisitDetail.doctorReceptionStatus) {
          this.$emit("showTip");
          return;
        } else {
          this.$emit("hideTip");
        }
      }
      this.init();
      this.showLastSymoptom = false;
      this.showWin = true;
    },
    close() {
      this.showWin = false;
      this.showMore = false;
    },
    clear() {
      this.selectList.forEach((i) => {
        i.Other = false;
        i.isCause = false;
      });
      this.$store.commit("patientCausePoolRemove", this.info.registerCode);
      setTimeout(() => {
        this.$refs.symptomSelect.clickSymptoms();
      }, 100);
    },

    async send() {
      if (!this.filterDtId) {
        //如果有过滤类型的话 就不验证症状的必选项等
        if (!this.$refs.symptomSelect.must()) return; //验证必选项
        if (
          !this.isJudgingSymptoms &&
          this.info.sex == "女" &&
          this.info.patientAge > 8 &&
          this.info.patientAge < 60
        ) {
          let obj = {
            patientCode: this.info.patientCode,
            patientAge: this.info.patientAge,
            fsex: this.info.sex,
            detailList: this.selectList.map((i) => {
              return { dsId: i.dsId };
            }),
          };
          this.$store.commit("openSpin");
          try {
            let judgingSymptoms_res = await this.api2("judgingSymptoms", obj);
            this.$store.commit("closeSpin");
            this.isJudgingSymptoms = true;
            if (
              judgingSymptoms_res.result &&
              judgingSymptoms_res.result.isRedMessage == "是"
            ) {
              let content = `<p>患者是13-60岁女性，无明显未孕症状，注意确认是否可能怀孕？若无问题，请继续提交。</p>`;
              this.$store.commit("setN_tip", {
                title: "小贴士",
                content,
              });
              return;
            }
          } catch (error) {
            this.$store.commit("closeSpin");
          }
        }

        if (!this.again) {
          try {
            let res = await this.getSpecialSymptomsRemind();
            if (res.result.length) return;
          } catch (error) { }
        }
      }

      try {
        if (
          this.selectEtiology &&
          (await this.$refs.etiologySelect.open(true))
        ) {
          return;
        }
      } catch (error) {}

      this.$emit("input", this.selectList);
      this.$emit("submit", this.selectList);
      this.showWin = false;
      this.showMore = false;
      document.querySelector("body").style.overflow = "auto";

      // 判断newDsIds和oldDsIds里的元素是否有变化 
      let newDsIds = this.selectList.map((i) => i.dsId);
      let isChange = newDsIds.some((i) => !this.oldDsIds.includes(i));
      if (!(newDsIds.length == this.oldDsIds.length && !isChange)){
        //如果有变化
        this.$emit("resertDialecticalSelect")
      }
    },

    // 特殊症状提醒 新
    getSpecialSymptomsRemind() {
      this.$store.commit("openSpin");
      let obj = {
        symptomCode: this.selectList.map((i) => i.dsId).join("|"), //	本次症状Id 格式:444|9666|999
        patientCode: this.info.patientCode, //	患者编码
      };
      return new Promise((resolve, reject) => {
        this.api2("getSpecialSymptomsRemind", obj)
          .then((res) => {
            let data = res.result;
            this.$store.commit("closeSpin");
            this.again = true;
            if (data.length) {
              let ds_names = data.map((i) => i.DS_Name).join("、");
              this.symptomList = data;
              this.symptomNames = ds_names;
              this.modal1 = true;
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    //冲突症状检测  返回冲突症状列表
    contradictValidate() {
      let list = u_common.clone(this.selectList);
      let arr = [];
      this.contradictDiagnosticList.SubType.forEach((i) => {
        let symptom1 = list.find((j) => j.parentId == i.dtId);
        let symptom2 = list.find((j) => j.parentId == i.dtId2);
        if (symptom1 && symptom2) {
          let item = arr.find((i) => i == symptom1);
          if (!item) arr.push(symptom1);
          let item2 = arr.find((i) => i == symptom2);
          if (!item2) arr.push(symptom2);
        }
      });

      this.contradictDiagnosticList.Symptom.forEach((i) => {
        let symptom1 = list.find((j) => j.dsId == i.dsId);
        let symptom2 = list.find((j) => j.dsId == i.dsId2);
        if (symptom1 && symptom2) {
          let item = arr.find((i) => i == symptom1);
          if (!item) arr.push(symptom1);
          let item2 = arr.find((i) => i == symptom2);
          if (!item2) arr.push(symptom2);
        }
      });
      return arr;
    },

    // 导入症状
    drzz(arr) {
      this.quote = {
        type: true,
        ids: arr.map((i) => i.DS_ID + ""),
      };
    },

    setIsCause() {
      setTimeout(() => {
        this.selectList.forEach((i) => {
          if (i.etiologyList.length) {
            i.isCause = true;
          } else {
            i.isCause = false;
          }
        });
      }, 300);
    },

    // 初始化
    init() {
      this.in_etiologyList = this.etiologyList;
      this.etiologyIds = this.etiologyIdObj;

      this.isJudgingSymptoms = false;
      this.selectList = this.value;

      this.setIsCause();

      if (this.value.length) {
        this.quote = {
          ids: this.value.map((i) => i.dsId + ""),
          type: false,
        };
      } else {
        this.quote = {
          ids: [],
          type: false,
        };
      }

      this.sexAndAge = {
        sex: this.info.sex == "女" ? 2 : 1,
        age: this.info.patientAge,
      };
      this.setDiagnosticListEtiologyList();
    },
  },
  created() {
    this.again = false; //再次提交
    this.init();
  },
  mounted() {
    // 视觉改变触发
    $(document).on("visibilitychange", (e) => {
      if (e.target.visibilityState === "visible") {
        this.focus();
      }
    });
  },
};
</script>

<style lang="scss">
.condition.symptom_select_input {
  min-height: 0;
}

.symptom_select_input {
  min-height: 26px;

  & > .text {
    cursor: pointer;
  }

  .mk_popup {
    left: 0px;
    bottom: 0px;
    right: 0px;
    width: auto;
  }

  .btn_group {
    position: absolute;
    z-index: 12;
    right: 10px;
    top: 8px;

    .ivu-btn {
      margin-left: 15px;
    }
  }

  .symptom_name {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 3px;
    font-weight: 400;
    font-size: 14px;
    background: #fbf7f4;
    margin: 0 10px 10px 0;
    cursor: pointer;
    user-select: none;

    &.isError {
      background: #f00;
      color: #fff;
    }

    &.symptom_name_remove:hover {
      background: url(../assets/images/x.png) no-repeat right top #dbceba;
    }
  }

  .ivu-modal-header-inner {
    width: auto;
    font-size: 16px;
  }

  .ivu-modal-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;
    background: #fff;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 100000;
  }
  .pathent-info {
    display: inline-block;
    margin-left: 15px;
    font-size: 14px;
    span {
      padding-right: 15px;
    }
    .iconfont {
      margin-right: 10px;
    }
    .pathent-info-name {
      font-weight: bold;
      font-size: 15px;
    }
  }

  .ivu-modal-body {
    padding: 0;
    overflow: hidden;
    display: flex;
    top: 48px;
  }

  .s_s_i_list {
    position: relative;
    flex-shrink: 0;
    height: 100%;
    padding: 15px 15px 15px 0;
    display: flex;
    flex-direction: column;
    background: #f5f5f5;
    .s_s_i_list_body {
      background: #fff;
      border-radius: 10px;
      // padding: 15px;
      height: 100%;
      display: flex;
    }

    .s_body {
      height: 100%;
      overflow-y: auto;
      .mk {
        margin-bottom: 10px;
      }
    }
    .mk_title {
      margin-bottom: 8px;
    }

    .s_header {
      display: flex;
      margin-bottom: 15px;
      align-items: center;
    }

    .s_header .ivu-btn {
      margin-left: 5px;
      font-size: 12px;
    }
  }

  .right {
    width: 320px;
    position: relative;
    padding: 15px;
    .title_right {
      display: flex;
      justify-content: space-between;
    }
  }
  .s_header2 {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    font-size: 13px;
    border-radius: 5px;
    margin-bottom: 15px;
    background: #f9f9fb;
    line-height: 2em;
  }
  .ivu-tabs-nav {
    width: 100%;
    :deep {
      .ivu-tabs-tab {
        width: 100%;
      }
    }
  }
  .ivu-modal-content {
    background: #fff;
  }
}
.symptom-omission-selection {
  .title {
    font-size: 15px;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .content {
    line-height: 2em;
    margin-bottom: 20px;
  }
  .footer {
    text-align: right;
    .ivu-btn {
      margin-left: 20px;
    }
  }
  .t_read {
    color: #f00;
  }
}
.not-selected {
  padding-top: 10px;
}
.symptom_select_input_tip {
  line-height: 30px;
  .phone,
  .name {
    font-weight: bold;
    font-size: 18px;
    margin-right: 10px;
  }
  .phone {
    font-weight: normal;
  }
  .footer {
    text-align: center;
    margin: 20px 0;
  }
}
.has-select-box {
  margin-bottom: 10px;
  .title {
    font-weight: bold;
  }
  .ivu-btn + .ivu-btn {
    margin-left: 10px;
  }
}
.hlwyy {
  .hlwyy-title {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: bold;
  }
  .hlwyy-info {
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;
    padding-bottom: 5px;
    overflow: hidden;
    & > div {
      margin-bottom: 10px;
    }
    .label {
      color: #999;
      font-weight: bold;
    }
    .pic .img-box {
      float: left;
      width: 60px;
      height: 60px;
      border: 1px solid #ccc;
      padding: 5px;
      margin: 0 10px 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      cursor: pointer;
    }
  }
}
</style>
